// Tooltip copy per check-in state
export const CHECK_IN_TOOLTIP = {
  out: "Checked out — click to check in",
  in: "Checked in — click to check out",
  pending: "Click to check in"
}

// Human-readable labels for the active payment filter chip
export const PAYMENT_CHIP_LABELS = {
  paid: "Paid",
  balance_due_operator_to_collect: "Balance Due (Operator To Collect)",
  balance_due_card_auto_collect: "Balance Due (Card Auto-collect)",
  balance_due_card_auto_collect_failed: "Balance Due (Card Auto-collect Failed)",
  balance_due_link_sent: "Balance Due (Link Sent)"
}

export const EMPTY_FILTERS = { payment: null, waivers: null, checkIn: null, experiences: [] }

// Filter modal option lists
export const PAYMENT_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "balance_due_operator_to_collect", label: "Balance Due (Operator To Collect)" },
  { value: "balance_due_card_auto_collect", label: "Balance Due (Card Auto-collect)" },
  { value: "balance_due_card_auto_collect_failed", label: "Balance Due (Card Auto-collect Failed)" },
  { value: "balance_due_link_sent", label: "Balance Due (Link Sent)" }
]

export const WAIVER_OPTIONS = [
  { value: "signed", label: "Signed" },
  { value: "not_signed", label: "Not Signed" }
]

export const CHECKIN_OPTIONS = [
  { value: "not_checked_in", label: "Not checked-in" },
  { value: "checked_in", label: "Checked-in" },
  { value: "checked_out", label: "Checked-out" }
]
